import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c8176e8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen" }
const _hoisted_2 = { class: "screen-action" }
const _hoisted_3 = { class: "action-btn-group" }
const _hoisted_4 = { class: "action-btn" }

import { useTrack } from '@/composables/twilio/useTrack'
import { IParticipantTrack } from '@/types/interfaces/participant.interface'
import { PropType } from 'vue'
import { useFullscreen } from '@vueuse/core'


export default /*#__PURE__*/_defineComponent({
  __name: 'ScreenTrack',
  props: {
  track: {
    type: Object as PropType<IParticipantTrack>,
    required: true,
  },
},
  setup(__props) {

const props = __props
const { trackRef } = useTrack(props.track)
const { toggle } = useFullscreen(trackRef)

return (_ctx: any,_cache: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_SvgIcon, {
            class: "action-icon _pointer-on-hover",
            icon: "fullscreen",
            "inherit-fill": true,
            height: "26",
            onClick: _unref(toggle)
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _createElementVNode("div", {
      ref_key: "trackRef",
      ref: trackRef,
      class: "video-track"
    }, null, 512)
  ]))
}
}

})